import { createContext, FC, PropsWithChildren } from 'react';
import { InterpreterFrom } from 'xstate';
import { useInterpret } from '@xstate/react';
import { flightRetryPaymentMachine } from 'obt-common';

export type ContextValue = InterpreterFrom<typeof flightRetryPaymentMachine>;
export const RetryPaymentXStateContext = createContext<ContextValue | null>(null);

const RetryPaymentXStateProvider: FC<PropsWithChildren> = ({ children }) => {
  const retryPaymentService = useInterpret(flightRetryPaymentMachine);

  return (
    <RetryPaymentXStateContext.Provider value={retryPaymentService}>{children}</RetryPaymentXStateContext.Provider>
  );
};

export default RetryPaymentXStateProvider;
